/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './error-dialog.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@ngx-translate/core/src/translate.pipe';
import * as i3 from '@ngx-translate/core/src/translate.service';
import * as i4 from '../../../../../app/profile/edition/dialog/error-dialog.component';
import * as i5 from '../../../../../$$_gendir/node_modules/@angular/material/button/typings/index.ngfactory';
import * as i6 from '@angular/material/core';
import * as i7 from '@angular/material/button';
import * as i8 from '@angular/cdk/platform';
import * as i9 from '@angular/cdk/a11y';
import * as i10 from '@angular/material/dialog';
const styles_ErrorDialogComponent:any[] = [i0.styles];
export const RenderType_ErrorDialogComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ErrorDialogComponent,data:{}});
export function View_ErrorDialogComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),20,'div',[['class',
      'deconnection-dialog']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),
      (null as any),2,'h2',([] as any[]),(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵpid(131072,
      i2.TranslatePipe,[i3.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),
      ['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted((null as any),['\n    '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
      2,'p',([] as any[]),(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted((null as any),['',''])),i1.ɵpid(131072,i2.TranslatePipe,
      [i3.TranslateService,i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),['\n  '])),
      (_l()(),i1.ɵted((null as any),['\n  '])),(_l()(),i1.ɵeld(0,(null as any),(null as any),
          6,'button',[['class','mat-button mat-raised-button'],['color','primary'],
              ['mat-button',''],['mat-raised-button',''],['type','reset']],[[8,'disabled',
              0]],[[(null as any),'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i4.ErrorDialogComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.dialogRef.close((null as any))) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_MatButton_0,i5.RenderType_MatButton)),i1.ɵdid(16384,(null as any),
          0,i6.MatPrefixRejector,([] as any[]),(null as any),(null as any)),i1.ɵdid(180224,
          (null as any),0,i7.MatButton,[i1.Renderer2,i1.ElementRef,i8.Platform,i9.FocusMonitor],
          {color:[0,'color']},(null as any)),i1.ɵdid(16384,(null as any),0,i7.MatButtonCssMatStyler,
          ([] as any[]),(null as any),(null as any)),i1.ɵdid(16384,(null as any),0,
          i7.MatRaisedButtonCssMatStyler,([] as any[]),(null as any),(null as any)),
      (_l()(),i1.ɵted(0,['\n    ','\n  '])),i1.ɵpid(131072,i2.TranslatePipe,[i3.TranslateService,
          i1.ChangeDetectorRef]),(_l()(),i1.ɵted((null as any),['\n'])),(_l()(),i1.ɵted((null as any),
          ['\n']))],(_ck,_v) => {
    const currVal_3:any = 'primary';
    _ck(_v,15,0,currVal_3);
  },(_ck,_v) => {
    var _co:i4.ErrorDialogComponent = _v.component;
    const currVal_0:any = i1.ɵunv(_v,3,0,i1.ɵnov(_v,4).transform(_co.data.messageType));
    _ck(_v,3,0,currVal_0);
    const currVal_1:any = i1.ɵunv(_v,9,0,i1.ɵnov(_v,10).transform(_co.data.message));
    _ck(_v,9,0,currVal_1);
    const currVal_2:any = (i1.ɵnov(_v,15).disabled || (null as any));
    _ck(_v,13,0,currVal_2);
    const currVal_4:any = i1.ɵunv(_v,18,0,i1.ɵnov(_v,19).transform(_co.data.button));
    _ck(_v,18,0,currVal_4);
  });
}
export function View_ErrorDialogComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,(null as any),(null as any),1,'app-error-dialog',
      ([] as any[]),(null as any),(null as any),(null as any),View_ErrorDialogComponent_0,
      RenderType_ErrorDialogComponent)),i1.ɵdid(49152,(null as any),0,i4.ErrorDialogComponent,
      [i10.MatDialogRef,i10.MAT_DIALOG_DATA],(null as any),(null as any))],(null as any),
      (null as any));
}
export const ErrorDialogComponentNgFactory:i1.ComponentFactory<i4.ErrorDialogComponent> = i1.ɵccf('app-error-dialog',
    i4.ErrorDialogComponent,View_ErrorDialogComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvcHJvZmlsZS9lZGl0aW9uL2RpYWxvZy9lcnJvci1kaWFsb2cuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvcHJvZmlsZS9lZGl0aW9uL2RpYWxvZy9lcnJvci1kaWFsb2cuY29tcG9uZW50LnRzIiwibmc6Ly8vdmFyL2Nocm9ub2Nhc2hWMy90ZXN0L3dlYmFwcC1jbGsvc3JjL2FwcC9wcm9maWxlL2VkaXRpb24vZGlhbG9nL2Vycm9yLWRpYWxvZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Zhci9jaHJvbm9jYXNoVjMvdGVzdC93ZWJhcHAtY2xrL3NyYy9hcHAvcHJvZmlsZS9lZGl0aW9uL2RpYWxvZy9lcnJvci1kaWFsb2cuY29tcG9uZW50LnRzLkVycm9yRGlhbG9nQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPGRpdiBjbGFzcz1cImRlY29ubmVjdGlvbi1kaWFsb2dcIj5cbiAgPGgyPnt7ZGF0YS5tZXNzYWdlVHlwZSB8IHRyYW5zbGF0ZX19PC9oMj5cbiAgPGRpdj5cbiAgICA8cD57e2RhdGEubWVzc2FnZSB8IHRyYW5zbGF0ZX19PC9wPlxuICA8L2Rpdj5cbiAgPGJ1dHRvbiBtYXQtYnV0dG9uIG1hdC1yYWlzZWQtYnV0dG9uIGNvbG9yPVwicHJpbWFyeVwiIHR5cGU9XCJyZXNldFwiIChjbGljayk9XCJkaWFsb2dSZWYuY2xvc2UobnVsbClcIj5cbiAgICB7eyBkYXRhLmJ1dHRvbiB8IHRyYW5zbGF0ZSB9fVxuICA8L2J1dHRvbj5cbjwvZGl2PlxuIiwiPGFwcC1lcnJvci1kaWFsb2c+PC9hcHAtZXJyb3ItZGlhbG9nPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBaUMseUNBQy9CO01BQUE7TUFBQSw4QkFBSTt1QkFBQSw0Q0FBcUM7TUFBQSxXQUN6QztNQUFBLHdFQUFLO2FBQUEsNEJBQ0g7TUFBQTtNQUFBLGdCQUFHO01BQUEsNENBQWdDO01BQy9CLHlDQUNOO1VBQUE7Y0FBQTtjQUFBO1lBQUE7WUFBQTtZQUFrRTtjQUFBO2NBQUE7WUFBQTtZQUFsRTtVQUFBLHVEQUFBO1VBQUEseUVBQUE7VUFBQTtVQUFBLDBDQUFBO1VBQUEsa0RBQUE7eUNBQUE7TUFBa0c7OEJBQUEsR0FFekYsdUNBQ0w7VUFBQTtJQUhpQztJQUFyQyxZQUFxQyxTQUFyQzs7O0lBSkk7SUFBQTtJQUVDO0lBQUE7SUFFTDtJQUFBLFlBQUEsU0FBQTtJQUFrRztJQUFBOzs7O29CQ0xwRztNQUFBO3FDQUFBLFVBQUE7TUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/profile/edition/dialog/error-dialog.component.ngfactory.ts